const educationprograms = {
	title: "Education Programs",
	new_educationprogram: "New Education Program",
	edit_educationprogram: "Edit Education Program: {name}",
	view_ceducationprogram: "View Education Program: {name}",
	list_title: "List of Education Programs",
	list_subtitle: "Manage Education Programs",
	create_title: "Create New Education Program",
	update_title: "Update Education Program",
	id: "ID",
	name: "Name",
	code: "Code",
	date_valid: "Date Valid",
	status: "Status",
	created_by: "Created By",
};
export default educationprograms;